import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import BackToTopButton from './BackToTopButton';
import LoginPromptBar from './LoginPromptBar';
import { Container } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { shouldShowLoginPrompt } from '../../utils/loginPromptPaths';

const Layout = ({ children }) => {
  const location = useLocation();
  const { currentUser, loading } = useAuth();
  const showLoginPrompt =
    !loading && !currentUser && shouldShowLoginPrompt(location.pathname);

  return (
    <>
      <Header />
      {showLoginPrompt && <LoginPromptBar />}
      <Container className={showLoginPrompt ? 'layout-with-login-prompt' : 'mt-5'}>
        {children}
      </Container>
      <Footer />
      <BackToTopButton />
    </>
  );
}

export default Layout;